<template>
  <div class="role-page page-padding-top">
    <top-bar :title="$t('content.title1')"  @back="back" ></top-bar>

    <div class="notice-detail">
      <h2>Privacy Policy</h2>
      <p class="last-updated">Last Updated: {{currentDate}}</p>
      
      <div class="section">
        <h3>1. Introduction</h3>
        <p>This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our digital asset trading platform. We respect your privacy and are committed to protecting your personal data.</p>
      </div>
      
      <div class="section">
        <h3>2. Information We Collect</h3>
        <p>We may collect the following types of information:</p>
        <h4>2.1 Personal Information</h4>
        <ul>
          <li><b>Identity Information:</b> Full name, date of birth, nationality, gender, signature, and government-issued identification.</li>
          <li><b>Contact Information:</b> Email address, phone number, residential address, and mailing address.</li>
          <li><b>Financial Information:</b> Bank account details, payment card details, and transaction history.</li>
          <li><b>Account Information:</b> Username, password, account preferences, and trading activity.</li>
        </ul>
        <h4>2.2 Automatically Collected Information</h4>
        <ul>
          <li><b>Device Information:</b> IP address, device type, browser type, operating system, and other technical information.</li>
          <li><b>Usage Information:</b> Access times, pages viewed, links clicked, and actions taken on our platform.</li>
          <li><b>Location Information:</b> General location information based on your IP address.</li>
          <li><b>Cookies and Similar Technologies:</b> Information collected through cookies, web beacons, and similar technologies.</li>
        </ul>
      </div>
      
      <div class="section">
        <h3>3. How We Use Your Information</h3>
        <ul>
          <li>To create and maintain your account</li>
          <li>To process transactions and provide our services</li>
          <li>To comply with legal and regulatory obligations, including KYC and AML requirements</li>
          <li>To verify your identity and prevent fraud</li>
          <li>To communicate with you about your account, transactions, and our services</li>
          <li>To personalize your experience and improve our platform</li>
        </ul>
      </div>
      
      <div class="section">
        <h3>4. How We Share Your Information</h3>
        <p>We may share your information with:</p>
        <ul>
          <li><b>Service Providers:</b> Third-party vendors who perform services on our behalf</li>
          <li><b>Business Partners:</b> Trusted third parties who help us provide our services</li>
          <li><b>Legal Authorities:</b> Government authorities and regulators when required by law</li>
          <li><b>Professional Advisors:</b> Lawyers, auditors, bankers, and insurers</li>
        </ul>
        <p>We will not sell your personal information to third parties for marketing purposes.</p>
      </div>
      
      <div class="section">
        <h3>5. Data Security</h3>
        <p>We implement appropriate technical and organizational measures to protect your personal data. Our security measures include:</p>
        <ul>
          <li>Encryption of sensitive data</li>
          <li>Regular security assessments</li>
          <li>Access controls and authentication procedures</li>
          <li>Continuous monitoring of our systems</li>
        </ul>
      </div>
      
      <div class="section">
        <h3>6. Your Rights</h3>
        <p>Depending on your location, you may have the following rights:</p>
        <ul>
          <li><b>Access:</b> Request a copy of your personal data</li>
          <li><b>Rectification:</b> Correct inaccurate or incomplete data</li>
          <li><b>Erasure:</b> Request deletion of your data in certain circumstances</li>
          <li><b>Objection:</b> Object to our processing of your data</li>
        </ul>
      </div>
      
      <div class="section">
        <h3>7. Contact Us</h3>
        <p>If you have any questions about this Privacy Policy, please contact us</p>
      </div>
    </div>
  </div>
</template>
<script>
import { getNoticeList } from '@/api/index'
import topBar from '@/components/topBar'
export default {
  components: {
    topBar
  },
  data() {
    return {
      title: '',
      currentDate: new Date().toISOString().split('T')[0]
    }
  },
  mounted() {
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    readAll() {

    }
  }
}
</script>
<style scoped>
.notice-detail {
  padding: 15px;
  color: #333;
  line-height: 1.5;
}

h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #0d47a1;
}

.last-updated {
  color: #666;
  font-style: italic;
  margin-bottom: 15px;
  font-size: 12px;
}

.section {
  margin-bottom: 20px;
}

h3 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  margin-top: 16px;
  color: #0d47a1;
}

h4 {
  font-size: 14px;
  font-weight: 600;
  margin-top: 12px;
  margin-bottom: 8px;
}

p {
  margin-bottom: 8px;
  font-size: 14px;
}

ul {
  padding-left: 16px;
  margin-bottom: 8px;
}

li {
  margin-bottom: 4px;
  font-size: 14px;
}

.contact-email {
  font-size: 16px;
  font-weight: 600;
  color: #0d47a1;
  margin: 12px 0;
}
</style>